import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrobitComponent } from './simple-icons-microbit.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrobitComponent ],
    exports:      [ SimpleIconsMicrobitComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrobitModule {}
